/* global wpApiSettings */

import formMessage from './form-message.js';
import autosize from 'autosize';

import { imageUpload } from '../index.js';

let $form;

function init() {

	$form = $('.form--story');

	if (!$form.length) {
		return;
	}

	imageUpload.init($form);

	const $story = $form.find('textarea[name="fields[story__copy]"]');

	autosize($story);

	$form.on('submit', (event) => {
		event.preventDefault();
		handleFormSubmit(event);
	});

	setPreviewLink();

}

function handleFormSubmit(event) {

	const data = new FormData($form.get(0));

	let formMessageText;
	let $formSubmit = $form.find('.form__submit');

	$formSubmit.prop('disabled', true).addClass('is--loading');

	$.ajax({
		url: $form.attr('action'),
		method: 'POST',
		processData: false,
		contentType: false,
		beforeSend: (xhr) => {
			// xhr.setRequestHeader('Authorization', `Basic ' . ${btoa(username + ':' + password)}`);
			xhr.setRequestHeader('X-WP-Nonce', wpApiSettings.nonce);
		},
		data: data
	})
	.done((data, textStatus, jqXHR) => {

		// const searchParams = new URLSearchParams(window.location.search);
		const postType = (data.type === 'kylahistoria_story') ? 'story' : 'place';


		if (jqXHR.status === 201) {

			window.history.replaceState({}, data.title, `${window.location.origin + window.location.pathname}?${postType}=${data.id}`);
			setPreviewLink(data.id);
			$form.attr('action', $form.attr('action') + data.id);
			formMessageText = 'Tarina lisätty!';

		} else if (jqXHR.status === 200) {

			formMessageText = 'Muutokset tallennettu!';

		}

		formMessage.handleEverything($form, formMessageText, 'success');
		$formSubmit.prop('disabled', false).removeClass('is--loading');

	})
	.fail((jqXHR, textStatus, errorThrown) => {

		formMessage.handleEverything($form, jqXHR.responseJSON.message, 'error');
		$formSubmit.prop('disabled', false).removeClass('is--loading');

	});

}

function setPreviewLink(itemID) {

	const $link = $form.find('.form__preview-link');
	const url = $link.data('href');
	const id = itemID || $link.data('id');

	if (url && id) {
		$link.attr('href', `${url}#tarina-${id}`).removeClass('disabled');
	}

}

export default {
	init
};
